
<form [formGroup]="formControlGroup" (keypress)="keyboardPress($event)" (keyup)="keyboardUp($event)">

    <h2 class="popup-title">
        {{languageService.Strings.additionalDataPopupStrings.title}}
    </h2>

    <div class="global-container">

        <!-- Age input -->
        <div class="input_box">
            <mat-form-field class="input-text" appearance="fill">
                <mat-label>
                    {{languageService.Strings.additionalDataPopupStrings.inputBoxLabelPatientAge}}
                </mat-label>
                <input type="number" min={{ageDict.minValue}} max={{ageDict.maxValue}} step={{ageDict.step}}
                    matInput [formControl]="numericFormControlAge" [errorStateMatcher]="matcher" autocomplete="off">
                <mat-error *ngIf="numericFormControlAge.hasError('max')" ngClass="error-class">
                    {{languageService.Strings.errors.error_maxValue}}
                </mat-error>
                <mat-error *ngIf="numericFormControlAge.hasError('min')" ngClass="error-class">
                    {{languageService.Strings.errors.error_minValue}}
                </mat-error>
                <mat-error *ngIf="numericFormControlAge.hasError('stepValidationError')" ngClass="error-class">
                    {{languageService.Strings.errors.error_step}}
                </mat-error>
            </mat-form-field>
        </div>   
        
        <!-- Weight input -->
        <div class="input_box">
            <mat-form-field class="input-text" appearance="fill">
                <mat-label>
                    {{languageService.Strings.additionalDataPopupStrings.inputBoxLabelPatientWeight}}
                </mat-label>
                <input type="number" min={{weightDict.minValue}} max={{weightDict.maxValue}} step={{weightDict.step}}
                    matInput [formControl]="numericFormControlWeight" [errorStateMatcher]="matcher" autocomplete="off">
                <mat-error *ngIf="numericFormControlWeight.hasError('max')" ngClass="error-class">
                    {{languageService.Strings.errors.error_maxValue}}
                </mat-error>
                <mat-error *ngIf="numericFormControlWeight.hasError('min')" ngClass="error-class">
                    {{languageService.Strings.errors.error_minValue}}
                </mat-error>
                <mat-error *ngIf="numericFormControlWeight.hasError('stepValidationError')" ngClass="error-class">
                    {{languageService.Strings.errors.error_step}}
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Height input -->
        <div class="input_box">
            <mat-form-field class="input-text" appearance="fill">
                <mat-label>
                    {{languageService.Strings.additionalDataPopupStrings.inputBoxLabelPatientHeight}}
                </mat-label>
                <input type="number" min={{heightDict.minValue}} max={{heightDict.maxValue}} step={{heightDict.step}}
                    matInput [formControl]="numericFormControlHeight" [errorStateMatcher]="matcher" autocomplete="off">
                <mat-error *ngIf="numericFormControlHeight.hasError('max')" ngClass="error-class">
                    {{languageService.Strings.errors.error_maxValue}}
                </mat-error>
                <mat-error *ngIf="numericFormControlHeight.hasError('min')" ngClass="error-class">
                    {{languageService.Strings.errors.error_minValue}}
                </mat-error>
                <mat-error *ngIf="numericFormControlHeight.hasError('stepValidationError')" ngClass="error-class">
                    {{languageService.Strings.errors.error_step}}
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Sex radio button -->
        <p class="pannel-buttons-title">
            {{languageService.Strings.additionalDataPopupStrings.radioButtonTitlePatientSex}}
        </p>
        <mat-radio-group 
            color="primary"
            class="pannel-buttons-container"
            formControlName="sex"  
            >
            <mat-radio-button 
                #currentButton
                mat-raised-button
                color="primary"
                class="single-button-container" 
                *ngFor="let value of sexValueList ; let i = index" 
                [value]=i
                [checked]=getRadioButtonIsChecked(i)
                (click)="radioButtonClicked($event, currentButton)">
                {{languageService.Strings.additionalDataPopupStrings.radioButtonLabelsPatientSex[i]}}
            </mat-radio-button>
        </mat-radio-group>

        <!-- Actions -->
        <div class="base_buttons_container">
            <!-- Exit button --> 
            <button mat-raised-button color="primary" class="base_buttons" (click)="exitButtonClicked()" style="width: 47%;">
                {{languageService.Strings.buttons.button_exit}}
            </button>  
            <!-- Save button -->        
            <button mat-raised-button color="primary" class="base_buttons" (click)="saveButtonClicked()" style="width: 47%;" [disabled]="!formControlGroup.valid"> 
                {{languageService.Strings.buttons.button_save}}
            </button>   
        </div>
    
    </div>

</form>